import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, SimpleFlexbox, Text, InputGroup, PhoneNumberToggle } from 'ctm-components';
import styles from './shielded.css';
import { rules } from './data.json';

class FormElements extends PureComponent {

    render = () => {
        const {
            name,
            phone,
            mobile,
            valid,
            directOptIn,
            shieldedRequestSent,
            nameId,
            dispatch,
            mobileId,
            phoneId,
            submit
        } = this.props;
        const suffix = !valid ? '_disabled' : '';
        const UIComponent = `btn_secondary_medium_semi_rounded${suffix}`;

        if (directOptIn && shieldedRequestSent) {
            return (
                <Text tagName="h2" className={styles.center}>
                    An expert from Shielded will contact you within 1 business day to help with
                    your insurance needs.
                </Text>
            );
        }

        return (
            <>
                <Text tagName="h2" className={styles.center}>
                    Add your contact details below and a Shielded expert will call to provide a quote.
                </Text>
                <SimpleFlexbox display="flex" column>
                    <SimpleFlexbox>
                        <InputGroup
                            storeValidation
                            type="input"
                            displayErrorMessage
                            rules={rules.name}
                            label="Name"
                            placeholder="Name"
                            value={name}
                            identifier={nameId}
                            dispatch={dispatch}
                        />
                    </SimpleFlexbox>
                    <SimpleFlexbox margin={'top_medium'}>
                        <PhoneNumberToggle
                            mobileValue={mobile}
                            phoneValue={phone}
                            storeValidation
                            mobileId={mobileId}
                            phoneId={phoneId}
                            mobileRules={rules.mobile}
                            phoneRules={rules.phone}
                        />
                    </SimpleFlexbox>
                </SimpleFlexbox>
                <SimpleFlexbox>
                    <Button
                        onClick={submit}
                        className={styles.submit_button}
                        variant="full_width"
                        UIComponent={UIComponent}
                        icon="ctm_arrow_right"
                    >
                        Call me back
                    </Button>
                </SimpleFlexbox>
            </>
        );
    };

}

FormElements.propTypes = {
    valid: PropTypes.bool.isRequired,
    submit: PropTypes.func.isRequired,
    phoneId: PropTypes.string.isRequired,
    mobileId: PropTypes.string.isRequired,
    nameId: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    name: PropTypes.string,
    mobile: PropTypes.string,
    phone: PropTypes.string,
    directOptIn: PropTypes.bool,
    shieldedRequestSent: PropTypes.bool
};

export { FormElements };
